import {cn} from '@bem-react/classname';
import {IClassNameProps} from '@bem-react/core';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ISettingFacade} from '../../../../../interfaces/settingData/ISettingFacade';
import {Button} from '../../../../components/Button';
import {Popup} from '../../../../components/Popup';
import './FacadeItemDelete.css';

export const cnFacadeItemDelete = cn('FacadeItemDelete');

export interface IFacadeItemDeleteProps extends IClassNameProps {
    facade: ISettingFacade;
    unitId: number;
    onRebuildData(method: string, value: any): void;
}

export const FacadeItemDelete: React.FC<IFacadeItemDeleteProps> =
    ({className, facade, onRebuildData}) => {
        const {t} = useTranslation();
        const [hover, setHover] = useState<boolean>(false);
        const tryDeleteFacade = () => {
            onRebuildData('tryDeleteFacadeItem', {facade: facade})
        }

        return (
            <div className={cnFacadeItemDelete({}, [className])}
                 onMouseEnter={() => {
                     setHover(true)
                 }}
                 onMouseLeave={() => {
                     setHover(false)
                 }}>
                <Button
                    className={cnFacadeItemDelete('Button')}
                    type={'button'}
                    leftIcon={{path: 'close', width: 20, height: 20}}
                    mods={{
                        mods: {bkg: 'transparent', fill: 'black'},
                        hover: {mods: {fill: 'pink'}}
                    }}
                    callBack={tryDeleteFacade}
                />
                {hover ? <Popup
                    active={hover}
                    className={cnFacadeItemDelete('Popup')}
                    position={{x: -2, y: -2}}
                >
                    <div className={cnFacadeItemDelete('HeaderPopup')}>{t('Удалить')}</div>
                </Popup> : null}

            </div>

        );
    }